import downloadFile from "../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../utils/commonFunctions/shortenFileName";
import { NewVideoFormDialogProps } from "../../../../@types/components/uploadAdministrationProps.types";
import {
	Button,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Tooltip,
	Chip,
	Fab,
	IconButton
} from "@material-ui/core";

import PublishIcon from "@material-ui/icons/Publish";
import SendIcon from "@material-ui/icons/Send";
import CheckIcon from "@material-ui/icons/Check";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import CloseIcon from "@material-ui/icons/Close";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

import "./newVideoFormDialog.css";

import { makeStyles } from "@material-ui/core/styles";

// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	paper: {
		overflowY: "unset",
		position: "relative"
	},
	customizedButton: {
		position: "absolute",
		right: 0,
		top: -10,
		zIndex: 99999
	}
}));

const NewVideoFormDialog = ({
	dialogProps,
	handleCloseDialog,
	handleVideoFileChange,
	handleVideoUrlChange,
	videoFile
}: NewVideoFormDialogProps) => {
	const { openDialog, title, buttonTitle, textFieldTitle, actions } = dialogProps;
	const classes = useStyles();
	// console.log("nvd: vf", videoFile);
	return (
		<div className="video-dialog">
			<Dialog
				open={openDialog}
				onClose={handleCloseDialog}
				aria-labelledby="form-dialog-title"
				className="video-dialog-container"
			>
				<DialogContent>
					<input
						className="video-dialog-upload"
						id="video-dialog-upload"
						name="upload"
						type="file"
						onChange={handleVideoFileChange}
						style={{ display: "none" }}
						accept="video/mp4"
						disabled={
							typeof videoFile === "string" && videoFile.length > 0
								? true
								: false || (typeof videoFile === "string" && videoFile.length === 0)
								? false
								: true || typeof videoFile === "object"
								? false
								: true
						}
					/>
					<label htmlFor={"video-dialog-upload"}>
						<Button
							className="video-dialog-btn-container"
							component="span"
							disabled={
								typeof videoFile === "string" && videoFile.length > 0
									? true
									: false || (typeof videoFile === "string" && videoFile.length === 0)
									? false
									: true || typeof videoFile === "object"
									? false
									: true
							}
						>
							{videoFile ? (
								typeof videoFile === "string" ? (
									<>
										<span className="video-btn-dialog-title">{buttonTitle}</span>
										<span>
											<PublishIcon className="video-btn-dialog-icon" />
										</span>
									</>
								) : (
									<Tooltip title={"Click to download"} arrow>
										<Chip
											label={
												videoFile && videoFile.originalname
													? shortenFileName(videoFile.originalname)
													: videoFile.name
													? shortenFileName(videoFile.name as string)
													: "No files added"
											}
											onClick={() => downloadFile(videoFile)}
										/>
									</Tooltip>
								)
							) : (
								<>
									<span className="video-btn-dialog-title">{buttonTitle}</span>
									<span>
										<PublishIcon className="video-btn-dialog-icon" />
									</span>
								</>
							)}
						</Button>
					</label>

					<div className="video-dialog-middle-txt">
						<span>Or</span>
					</div>
					<TextField
						id="outlined-basic"
						placeholder={textFieldTitle}
						variant="outlined"
						className="video-dialog-txtfield"
						disabled={typeof videoFile === "string" ? false : videoFile ? true : false}
						onChange={handleVideoUrlChange}
					/>
				</DialogContent>

				<DialogActions className="custom-dialog-actions-button-container">
					{actions.map((action, index) => {
						const { label, name, callback } = action;
						return (
							<Button
								className={
									name === "confirm"
										? "custom-dialog-action-button-green"
										: "custom-dialog-action-button-grey"
								}
								variant="contained"
								key={index}
								onClick={callback}
							>
								<span className="custom-dialog-action-button-label-with-icon">{label}</span>
								<span>
									{name === "confirm" ? (
										<ThumbUpIcon className="custom-dialog-action-button-icon" />
									) : (
										<CloseIcon className="custom-dialog-action-button-icon" />
									)}
								</span>
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default NewVideoFormDialog;
